export const USER_LOGIN_PROCESS = "USER_LOGIN_PROCESS"
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"
export const USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE"

export const USER_SIGNUP_PROCESS = "USER_SIGNUP_PROCESS"
export const USER_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS"
export const USER_SIGNUP_FAILURE = "USER_SIGNUP_FAILURE"

